<template>
  <div class="text-center green white--text" v-if="active">
    <p class="mb-0">PROMOCIÓN PUBLICADA</p>
  </div>
  <div class="text-center primary white--text" v-else>
    <p class="mb-0">PROMOCIÓN INACTIVA</p>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
